import { Component, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";


@Component({
  selector: 'app-edit-contact-modal',
  templateUrl: './edit-contact-modal.component.html',
  styleUrls: ['./edit-contact-modal.component.scss']
})
export class EditContactModalComponent implements OnInit {

  public edit_contact_detail: any = {};

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,

  ) {}

  ngOnInit() {}

  public closeModal() {
    this.bsModalRef.hide();
    /*   this.modalService.setDismissReason('modalClosed');*/
    this.modalService.setDismissReason("modalClosed");
  }

  public closeModalAfterSave() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalSaved");
  }

  public editContact(event) {
    this.closeModalAfterSave()
  }

}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/edit-contact-modal/edit-contact-modal.component.ts